// Web replacement for react-native-safe-area-context.
// Every screen in this app only uses `SafeAreaView` for basic layout —
// there are no real notches/insets on desktop or mobile browser chrome the
// way there are on a native phone, so zero insets are correct here.
import React from 'react';
import { View, StyleSheet } from 'react-native-web';

const ZERO_INSETS = { top: 0, right: 0, bottom: 0, left: 0 };

export function SafeAreaView({ style, children, ...rest }) {
  return (
    <View style={[{ flex: 1 }, style]} {...rest}>
      {children}
    </View>
  );
}

export function SafeAreaProvider({ children, style }) {
  return <View style={[{ flex: 1 }, style]}>{children}</View>;
}

export function useSafeAreaInsets() {
  return ZERO_INSETS;
}

export function useSafeAreaFrame() {
  const { width, height } = StyleSheet.absoluteFillObject ? { width: 0, height: 0 } : { width: 0, height: 0 };
  return { x: 0, y: 0, width: typeof window !== 'undefined' ? window.innerWidth : width, height: typeof window !== 'undefined' ? window.innerHeight : height };
}

export const SafeAreaInsetsContext = React.createContext(ZERO_INSETS);
export const initialWindowMetrics = { insets: ZERO_INSETS, frame: { x: 0, y: 0, width: 0, height: 0 } };
